import React, { useState, useEffect } from "react";

import {
  Button,
  TextField,
  Box,
  Stack,
  Alert,
  Paper,
  Typography,
} from "@mui/material";
import { PersonAdd as PersonAddIcon } from "@mui/icons-material";

import DB from "_DatabaseFunctions/directConnect";

interface AddToCurrentPlayersFieldProps {
  gameInfo: {
    id: string;
    status: string;
    currentPlayers: Record<string, unknown>;
    maxPlayers: number;
  };
  setModalDets: (dets: { open: boolean; status: string }) => void;
}

export default function AddToCurrentPlayersField({
  gameInfo,
  setModalDets,
}: AddToCurrentPlayersFieldProps) {

  const [playerName, setPlayerName] = useState("");
  const gameId = gameInfo.id;

  const [msg, setMsg] = useState("");

  const addPlayerManually = async (event: React.FormEvent) => {
    event.preventDefault();
    if (gameInfo.status !== "Running") {
      setModalDets({
        open: true,
        status: "errorRunning",
      });
    } else if (
      Object.keys(gameInfo.currentPlayers).length >= gameInfo.maxPlayers
    ) {
      setModalDets({
        open: true,
        status: "errorMaxPlayers",
      });
    } else {
      const res = await DB.addPlayerToTableManually(gameId, playerName);
      setMsg(res.msg);
      setPlayerName("");
      
      // Clear message after 3 seconds
      setTimeout(() => {
        setMsg("");
      }, 3000);
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom sx={{ mb: 2, fontWeight: 500, color: "text.primary", fontSize: "1.1rem" }}>
        Add Player to Current Game
      </Typography>
      
      <Box
        component="form"
        onSubmit={(event) => addPlayerManually(event)}
        sx={{ width: "100%" }}
      >
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <TextField
            fullWidth
            variant="outlined"
            label="Player Name"
            placeholder="Enter player's name"
            value={playerName}
            onChange={(event) => setPlayerName(event.target.value)}
            required
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="success"
            startIcon={<PersonAddIcon />}
            onClick={(event) => addPlayerManually(event)}
            size="large"
            sx={{
              minWidth: 200,
              fontWeight: 500,
              borderRadius: 2,
              whiteSpace: "nowrap",
            }}
          >
            Add to Game
          </Button>
        </Stack>
      </Box>
      
      {msg && (
        <Alert 
          severity={msg.includes("added to table successfully") ? "success" : "error"} 
          sx={{ mt: 2 }}
        >
          {msg}
        </Alert>
      )}
    </Paper>
  );
}
